var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueued(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.75,
    width: 22,
    height: 22,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3 5.25C15.4105 5.25 15.5 5.33954 15.5 5.45V17.05C15.5 17.1605 15.4105 17.25 15.3 17.25H14.2C14.0895 17.25 14 17.1605 14 17.05V5.45C14 5.33954 14.0895 5.25 14.2 5.25H15.3Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.55 5.25C11.6605 5.25 11.75 5.33954 11.75 5.45V17.05C11.75 17.1605 11.6605 17.25 11.55 17.25H10.45C10.3395 17.25 10.25 17.1605 10.25 17.05V5.45C10.25 5.33954 10.3395 5.25 10.45 5.25H11.55Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8 5.25C7.91046 5.25 8 5.33954 8 5.45V17.05C8 17.1605 7.91046 17.25 7.8 17.25H6.7C6.58954 17.25 6.5 17.1605 6.5 17.05V5.45C6.5 5.33954 6.58954 5.25 6.7 5.25H7.8Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7671 8.76707L19.7429 10.7429C19.7468 10.7468 19.7468 10.7532 19.7429 10.7571L17.7671 12.7329C17.7608 12.7392 17.75 12.7348 17.75 12.7259V8.77414C17.75 8.76523 17.7608 8.76077 17.7671 8.76707Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 16V19.5C3.5 20.0523 3.94772 20.5 4.5 20.5H17.5C18.0523 20.5 18.5 20.0523 18.5 19.5V16",
    stroke: "#333333",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueued);
export default __webpack_public_path__ + "static/media/queued.e5ac6ca24dd53f1358d1ba48733c5d5d.svg";
export { ForwardRef as ReactComponent };